//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete } from '@/api/PMS/repair/repairManagement';
import { fetchListByType } from '@/api/PMS/dic/dic';
import waves from '@/directive/waves'; // 水波纹指令

import repairAdd from './add';
import repairDetail from './detail';
import repairDispatch from './dispatch';
import repairEvaluate from './evaluate';
import repairArchive from './archive';
import repairConfirm from './confirm';
export default {
  components: {
    repairAdd: repairAdd,
    repairDetail: repairDetail,
    repairDispatch: repairDispatch,
    repairEvaluate: repairEvaluate,
    repairArchive: repairArchive,
    repairConfirm: repairConfirm
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: false,
      flowNum: '',
      repairStatu: [],
      typeOption: [],
      degreeOption: [],
      sourceOption: [],
      options: [],
      innerVisible: false,
      propstree: {
        label: 'name',
        value: 'id',
        children: 'pmsTree'
      },
      listQuery: {
        page: 1,
        limit: 10
      },
      title: '',
      customerId: '',
      id: '',
      multipleSelection: [],
      dialogConfirmVisible: false,
      dialogFormVisible: false,
      dialogDetailVisible: false,
      dialogDispatchVisible: false,
      dialogEvaluateVisible: false,
      dialogArchiveVisible: false
    };
  },
  created: function created() {
    this.typeOption = [];
    this.repairStatu = [];
    this.degreeOption = [];
    this.sourceOption = [];
    this.getList();
    this.loadTypeOptions();
    this.loadStatuOptions();
    this.loadDegreeOptions();
    this.loadSourceOptions();
  },
  methods: {
    // 确认
    handleConfirm: function handleConfirm(customerId, flowNum) {
      console.log('customerId, flowNum', customerId, flowNum);
      this.flowNum = flowNum;
      this.customerId = customerId;
      this.title = '确认';
      this.dialogConfirmVisible = true;
    },
    handCancle: function handCancle(reload) {
      switch (reload) {
        case true:
          this.getList();
          this.dialogFormVisible = false;
          break;

        case 'dispatchRepair':
          this.dialogDispatchVisible = false;
          this.getList();
          break;

        case 'repairAdd':
          this.getList();
          this.dialogFormVisible = false;
          break;

        case 'repairDetail':
          this.getList();
          this.dialogDetailVisible = false;
          break;

        case 'repairEvaluate':
          this.getList();
          this.dialogEvaluateVisible = false;
          break;

        case 'repairConfirm':
          this.getList();
          this.dialogConfirmVisible = false;
          break;

        case 'repairArchive':
          this.getList();
          this.dialogArchiveVisible = false;
          break;
      }
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 获取报修类型
    loadTypeOptions: function loadTypeOptions() {
      var _this2 = this;

      fetchListByType('repair_type').then(function (r) {
        _this2.typeOption = r.data.data;
      });
    },
    // 获取报修状态
    loadStatuOptions: function loadStatuOptions() {
      var _this3 = this;

      fetchListByType('repair_state').then(function (r) {
        _this3.repairStatu = r.data.data;
      });
    },
    // 获取工单优先级
    loadDegreeOptions: function loadDegreeOptions() {
      var _this4 = this;

      fetchListByType('emergency_degree').then(function (r) {
        _this4.degreeOption = r.data.data;
      });
    },
    // 获取来源
    loadSourceOptions: function loadSourceOptions() {
      var _this5 = this;

      fetchListByType('source').then(function (r) {
        _this5.sourceOption = r.data.data;
      });
    },
    // 创建
    handleCreate: function handleCreate() {
      this.customerId = '';
      this.title = '添加';
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(customerId, flowNum) {
      this.flowNum = flowNum;
      this.customerId = customerId;
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    // 派工
    handleDispatch: function handleDispatch(id, flowNum) {
      this.id = id;
      this.flowNum = flowNum;
      this.title = '派工';
      this.dialogDispatchVisible = true;
    },
    // 评价
    handleEvaluate: function handleEvaluate(id) {
      this.id = id;
      this.title = '回访评价';
      this.dialogEvaluateVisible = true;
    },
    // 归档
    handleArchive: function handleArchive(id, flowNum) {
      this.id = id;
      this.flowNum = flowNum;
      this.title = '归档';
      this.dialogArchiveVisible = true;
    },
    // 报修详情
    getDetail: function getDetail(id, flowNum) {
      this.id = id;
      this.flowNum = flowNum;
      this.title = '报修详情';
      this.dialogDetailVisible = true;
    },
    delete: function _delete(customerIds) {
      var _this6 = this;

      if (customerIds.length > 0) {
        this.$confirm('你确定是要删除报修记录, 是否继续?', '提示').then(function () {
          fetchDelete(customerIds).then(function (response) {
            _this6.getList();

            _this6.Alert({
              alertType: 'delete'
            });
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(customerId) {
      var customerIds = [];
      customerIds.push(customerId);
      this.delete(customerIds);
    }
  }
};